/**
 * @generated SignedSource<<110310c171f01c2f1af6f1de4dda887a>>
 * @relayHash bff6e86fe29b36f78cfc43e157544d06
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-commerce/458.0.0-2024-04-17T06:58:39.973Z/submitStripePaymentMethodSaveStripeMethodMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PaymentMethodType = "ACH" | "AFFIRM_CREDIT_CARD" | "APPLE_PAY" | "APPLIED_SALE" | "CASH" | "CHECK" | "CREDIT_CARD" | "CREDIT_TO_USER_ACCOUNT" | "DIRECT_PAYMENT" | "DISCOUNT" | "HYPERWALLET" | "KLARNA" | "ON_PLATFORM_WIRE_TRANSFER" | "OTHER" | "PAYPAL_ACCOUNT" | "PAY_LATER" | "UNKNOWN" | "WIRE_TRANSFER" | "%future added value";
export type PaymentProcessor = "BRAINTREE" | "KLARNA" | "OFF_PLATFORM" | "STRIPE" | "%future added value";
export type SaveStripePaymentMethodProcessor = "PRODUCTION" | "TEST" | "%future added value";
export type SaveStripePaymentMethodInput = {
  clientMutationId?: string | null;
  currency: Currency;
  mockWallet?: boolean | null;
  paymentMethodToken: string;
  paymentProcessorEnvironment?: SaveStripePaymentMethodProcessor | null;
  userId: string;
};
export type submitStripePaymentMethodSaveStripeMethodMutation$variables = {
  input: SaveStripePaymentMethodInput;
};
export type submitStripePaymentMethodSaveStripeMethodMutation$data = {
  readonly saveStripePaymentMethod: {
    readonly user: {
      readonly hasBankAccounts: boolean | null;
      readonly hasCreditCards: boolean | null;
      readonly wallet: {
        readonly paymentMethods: ReadonlyArray<{
          readonly currencies: ReadonlyArray<Currency | null> | null;
          readonly paymentMethod: {
            readonly accountHolderName?: string | null;
            readonly accountType?: string | null;
            readonly bankName?: string | null;
            readonly cardExpiryMonth?: string | null;
            readonly cardExpiryYear?: string | null;
            readonly cardHolderName?: string | null;
            readonly cardLogo?: string | null;
            readonly cardType?: string | null;
            readonly display?: string | null;
            readonly email?: string | null;
            readonly formattedTextMaskedCardNumber?: string | null;
            readonly hashedCardNumber?: string | null;
            readonly isExpired?: boolean | null;
            readonly last4?: string | null;
            readonly maskedCardNumber?: string | null;
            readonly paymentMethodType: PaymentMethodType | null;
            readonly paymentProcessor?: PaymentProcessor | null;
            readonly routingNumber?: string | null;
            readonly token?: string | null;
          } | null;
          readonly shippingAddresses: ReadonlyArray<{
            readonly serviceId: string | null;
          } | null> | null;
        } | null> | null;
      } | null;
    } | null;
    readonly walletPaymentMethod: {
      readonly currencies: ReadonlyArray<Currency | null> | null;
      readonly paymentMethod: {
        readonly __typename: string;
        readonly email?: string | null;
        readonly paymentProcessor: PaymentProcessor | null;
        readonly token?: string | null;
      } | null;
      readonly shippingAddresses: ReadonlyArray<{
        readonly serviceId: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type submitStripePaymentMethodSaveStripeMethodMutation = {
  response: submitStripePaymentMethodSaveStripeMethodMutation$data;
  variables: submitStripePaymentMethodSaveStripeMethodMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencies",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentMethodType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentProcessor",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExpired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardHolderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardExpiryMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardExpiryYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maskedCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hashedCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardLogo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedTextMaskedCardNumber",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "type": "CreditCard",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/),
    (v5/*: any*/)
  ],
  "type": "PayPalAccount",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "display",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountHolderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "routingNumber",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bankName",
      "storageKey": null
    }
  ],
  "type": "ACH",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "type": "ApplePay",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "shippingAddresses",
  "plural": true,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCreditCards",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBankAccounts",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = [
  (v4/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "paymentMethod",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v16/*: any*/),
      "type": "CreditCard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        (v7/*: any*/)
      ],
      "type": "PayPalAccount",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v16/*: any*/),
      "type": "ApplePay",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v16/*: any*/),
      "type": "ACH",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "shippingAddresses",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submitStripePaymentMethodSaveStripeMethodMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveStripePaymentMethodPayload",
        "kind": "LinkedField",
        "name": "saveStripePaymentMethod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Wallet",
                "kind": "LinkedField",
                "name": "wallet",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WalletPaymentMethod",
                    "kind": "LinkedField",
                    "name": "paymentMethods",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "paymentMethod",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletPaymentMethod",
            "kind": "LinkedField",
            "name": "walletPaymentMethod",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v17/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "submitStripePaymentMethodSaveStripeMethodMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveStripePaymentMethodPayload",
        "kind": "LinkedField",
        "name": "saveStripePaymentMethod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Wallet",
                "kind": "LinkedField",
                "name": "wallet",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WalletPaymentMethod",
                    "kind": "LinkedField",
                    "name": "paymentMethods",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "paymentMethod",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletPaymentMethod",
            "kind": "LinkedField",
            "name": "walletPaymentMethod",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-commerce/458.0.0-2024-04-17T06:58:39.973Z/submitStripePaymentMethodSaveStripeMethodMutation",
    "metadata": {},
    "name": "submitStripePaymentMethodSaveStripeMethodMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d0ed7af8cd4568ea41e6061624b078cd";

export default node;
